import {
    GridCellKind,
    getMiddleCenterBias,
} from "@glideapps/glide-data-grid";
import { dispatch, state } from "store";
const renderer = {
    kind: GridCellKind.Custom,
    isMatch: (c) => c.data?.kind === "json",
    needsHover: true,
    needsHoverPosition: true,
    onClick: (args, cell, cellId) => {
        const st = state()
        const heading = st.datagrid.headings.filter(h => !h.hidden).find(a => a._id === cellId)
        const payload = {
            type: 'OPEN_CELL_RUN_LOG',
            payload: {
                rowId: cell.rowId,
                cell: cellId,
                type: 'output',
                data: cell.data.originalValue,
                kind: cell.data.kind,
                isAI: heading.type === 'AI' || heading.type === 'Waterfall',
                heading
            }
        }
        dispatch(payload);
        return undefined
    },
    draw: (args, cell) => {
        const { ctx, theme, rect } = args;
        const { value } = cell.data;
        ctx.fillStyle = theme.textDark;
        ctx.fillText(
            JSON.stringify(value),
            rect.x + theme.cellHorizontalPadding,
            rect.y + rect.height / 2 + getMiddleCenterBias(ctx, theme)
        );

        return true;
    },
    measure: (ctx, cell, theme) => {
        const { value } = cell.data;
        return ctx.measureText(JSON.stringify(value)).width + theme.cellHorizontalPadding * 2;
    },
    provideEditor: undefined,
};

export default renderer;
